import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4731c0e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-content"
};
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ImagePreviewer = _resolveComponent("ImagePreviewer");
  const _component_video_previewer = _resolveComponent("video-previewer");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "c-content-wrap",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.handleHref && $options.handleHref(...args))
  }, [_createElementVNode("div", {
    class: "c-content-html",
    innerHTML: $options.finalContent
  }, null, 8, _hoisted_2)]), _createVNode(_component_ImagePreviewer, {
    show: $data.preivewImage.visible,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.preivewImage.visible = $event),
    images: $data.preivewImage.images
  }, null, 8, ["show", "images"]), _createVNode(_component_video_previewer, {
    modelValue: $data.previewVideoOptions.visible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.previewVideoOptions.visible = $event),
    type: $data.previewVideoOptions.type,
    src: $data.previewVideoOptions.src
  }, null, 8, ["modelValue", "type", "src"])]);
}